<template>
  <Window
    ref="reminder"
    :btnCancel="false"
    :title="''"
    :btnClose="false"
    :size="'xs'"
    :btnMode="'upDown'"
  >
    <div>
      <div class="taC fs14x">{{getLanguageStr("AS44","温馨提示")}}</div>
      <div
        class="mt2x mb1x"
      >{{$t('AS45',[$t(`${businessCode}`),'欢迎您使用xx'])}}{{getLanguageStr('AS46','我们将依据')}}
			<a
			:href="stage.setting.loc.privacyStatementUrl[stage.languageId]"
			target="_blank"
			class="cPrimary"
		>{{getLanguageStr("user96","《服务协议》")}}</a>
		<template v-if="stage.setting.loc.privacyPolicyUrl">
			{{getLanguageStr("all29","和")}}
			<a
				:href="stage.setting.loc.privacyPolicyUrl[stage.languageId]"
				target="_blank"
				class="cPrimary"
			>{{getLanguageStr("AS57","《隐私政策》")}}</a>
		</template>
		{{getLanguageStr("AS47",'来帮助您了解我们在收集、使用、存储和共享您个人信息的情况以及您享有的权利。')}}
		</div>
      <div>
        {{getLanguageStr("AS48",'1.为向您提供电站及设备的监控运维相关基本功能，我们会收集、使用必要的信息；')}}
      </div>
			<div>
        {{getLanguageStr("AS49",'2.基于您的明示授权，我们可能会获取您的位置（为您提供创建电站服务等）、设备号信息（以保障您账号安全）等信息，您有权拒绝或取消授权；')}}
      </div>
			<div>
				{{getLanguageStr("AS50",'3.我们会采取业界先进的安全措施保护您的信息安全；')}}
			</div>
			<div>
				{{getLanguageStr("AS51",'4.未经您同意，我们不会从第三方处获取、共享或向其提供您的信息；')}}
			</div>
			<div>
				{{getLanguageStr("AS52",'5.您可以查询、下载、更正、删除您的个人信息，我们也提供账户注销的渠道')}}
			</div>
    </div>
    <button
      class="functionBtn tra-fast"
      @click.stop="hide()"
      :title="$t('all32',['同意并进入'])"
      type="button"
      slot="btmBtnUD"
      style="padding:1em 0;margin:3em 2em 2em;"
    >{{$t('all32',['同意并进入'])}}</button>
    <button slot="btmBtnUD" @click="refuse">{{getLanguageStr("all33","不同意")}}</button>
    <div class="cb"></div>
  </Window>
</template>
<script>
// import {mapGetters} from 'vuex';
import * as lib from '@/util/lib';
import {getLanguageStr} from '@/util/language';
import Window from '@/components/common/ui/WindowForAlert';
import Checkbox from '@/components/common/ui/Checkbox.vue';
import {setPrivacyPolicyYes, getPrivacyPolicy} from '@/api/login';
import * as authUtils from '@/util/auth';
export default {
	name: 'reminder',
	props: {
		title: {
			// 设置弹窗的标题
			type: String,
			default: ''
		}
	},
	components: {
		Window,
		Checkbox
	},
	data () {
		return {
			stage,
			businessCode: stage.loc.platformName
		};
	},
	methods: {
		getLanguageStr,
		getTypeText: lib.getTypeText,
		async getYES () {
			var token = authUtils.getToken();
			if (token) {
				let req = {
					system: stage.loc.customer,
					clientType: 'Web',
					businessType: stage.loc.platformCode
				};
       	await getPrivacyPolicy(req).then(
					res => {
						if (res) {
			        	window.readPrivacy = true;
							return true;
						} else {
				       window.readPrivacy = false;
							this.show();
							return false;
						}
					},
					error => {
						!_.isEmpty(error) && this.$notify(error);
					}
				);
			}
		},
		show () {
			this.$refs.reminder.show();
		},
		refuse () {
			this.$toast(
				getLanguageStr(
					'all34',
					'抱歉，您需要同意《服务协议》与《隐私协议》后才能使用本软件'
				)
			);
			return false;
		},
		setFirst () {
			lib.setCookie('firstPrivacy', true);
			this.$refs.reminder.hide();
			return true;
		},
		setYes () {
			lib.setCookie('firstPrivacy', true);
			var token = authUtils.getToken();
			if (token) {
				let data = {
					businessType: stage.loc.platformCode,
					clientType: 'Web',
					readStatus: 1,
					system: stage.loc.customer
				};
				setPrivacyPolicyYes(data).then(
					res => {
						if (this.$route.path == '/login') {
							this.$emit('loginAgain');
						}
						this.$refs.reminder.hide();
						return res;
					},
					error => {
						!_.isEmpty(error) && this.$notify(error);
					}
				);
			}
			this.$emit('check');
		},
		hide () {
			this.setYes();
			this.$refs.reminder.hide();
			return true;
			//   if (lib.getCookie("privacyAgreementPrompt")) {
			//     this.setYes();
			//   } else {

			//   }
		}
	}
};
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/view/frame/Reminder.vue